import React from 'react'
import { Clock } from 'lucide-react'
import StoryCard from './StoryCard'

export default function TimeGroup({ label, stories, maxHeat }) {
  if (!stories || stories.length === 0) return null

  return (
    <section>
      <div className="flex items-center gap-2.5 md:gap-3 mb-2 md:mb-3 px-0.5">
        <Clock className="w-3.5 h-3.5 text-gray-600 flex-shrink-0" />
        <h3 className="text-[11px] md:text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap">{label}</h3>
        <div className="flex-1 h-px bg-white/5" />
      </div>
      <div className="space-y-0 md:space-y-2">
        {stories.map(story => (
          <StoryCard key={story.id} story={story} maxHeat={maxHeat} />
        ))}
      </div>
    </section>
  )
}
